import {
    ADD_ATTRIBUT_ROW_SUCCESS,
    REMOVE_ATTRIBUT_ROW_SUCCESS,
    UPDATE_ATTRIBUT_ROW_SUCCESS,
    CLEAR_ATTRIBUT_ROW_SUCCESS,
  } from "./type";
  
 
  
  // ***attributRows action***
  export const addAttributRow = (row) => {
    return {
      type: ADD_ATTRIBUT_ROW_SUCCESS,
      payload: row,
    };
  };
  
  export const RemoveAttributRow = (idRow) => {
    return {
      type: REMOVE_ATTRIBUT_ROW_SUCCESS,
      payload: idRow,
    };
  };
  
  export const updateAttributRow = (attributesIndex, attribut, values, attributId) => {
    console.log("update",attributesIndex, attribut, values, attributId);
    return {
      type: UPDATE_ATTRIBUT_ROW_SUCCESS,
      payload: { attributesIndex, attribut, values , attributId},
    };
  };
  
  export const clearAttributRow = () => {
    return {
      type: CLEAR_ATTRIBUT_ROW_SUCCESS,
      payload: [],
    };
  };
  